import {type ThemeOptions} from '@mui/material';

const typography: ThemeOptions['typography'] = {
  fontFamily: 'CircularBook',
  h1: {
    fontFamily: 'CircularLight',
  },
  h2: {
    fontFamily: 'CircularLight',
  },
  h3: {
    fontFamily: 'CircularRegular',
  },
  h4: {
    fontFamily: 'CircularRegular',
  },
  h5: {
    fontFamily: 'CircularBook',
    fontWeight: 700,
    fontSize: '24px',
    fontStyle: 'normal',
  },
  h6: {
    fontFamily: 'CircularBook',
    fontSize: '16px',
    lineHeight: '120%',
  },
  subtitle1: {
    fontFamily: 'CircularRegular',
  },
  subtitle2: {
    fontFamily: 'CircularMedium',
  },
  body1: {
    fontFamily: 'CircularRegular',
    fontWeight: 400,
    fontSize: '15px',
  },
  body2: {
    fontFamily: 'CircularBook',
  },
  body3: {
    fontFamily: 'CircularBook',
    fontSize: '12px',
  },
  button: {
    fontFamily: 'CircularBook',
  },
  caption: {
    fontFamily: 'CircularMedium',
    fontSize: '12px',
    lineHeight: '120%',
  },
  description: {
    fontFamily: 'CircularRegular',
    fontSize: '12px',
    letterSpacing: '0.02em',
    lineHeight: '130%',
    opacity: 0.8,
  },
  overline: {
    fontFamily: 'CircularRegular',
  },
  paperTitle: {
    fontFamily: 'CircularMedium',
    textTransform: 'uppercase',
    fontSize: '14px',
  },
  monospaced: {
    fontFamily: 'CircularMonoRegular',
  },
};

export default typography;
